import PropTypes from 'prop-types'

export const shapeTaxonWithLink = PropTypes.shape({
    id: PropTypes.number, // Int
    code: PropTypes.number, // Int
    latinName: PropTypes.string, // String
    status: PropTypes.string, // String
    creationDate: PropTypes.number, // Date
    updateDate: PropTypes.number, // Date
    author: PropTypes.string, // String
    writter: PropTypes.string, // String
    name: PropTypes.string, // String
    bibliographicReference: PropTypes.string, // String
    comment: PropTypes.string, // String
    active: PropTypes.bool, // Boolean
    elementOf: PropTypes.any, // Object
    theme: PropTypes.any, // Object
    level: PropTypes.any, // Object
    omnidiaCode: PropTypes.string, // String
    calculTaxonCode: PropTypes.string, // String
    refmuseum: PropTypes.string, // String
    basionym: PropTypes.string, // String
    synonyms: PropTypes.array, // Array
    characteristics: PropTypes.string, // String
    morphology: PropTypes.string, // String
    ecology: PropTypes.string, // String
    noteibd: PropTypes.string, // String
    noteips: PropTypes.string, // String
    notes: PropTypes.string, // String
    observations: PropTypes.string, // String
    contributorComment: PropTypes.string, // String
    speciesType: PropTypes.string, // String
    speciesStatus: PropTypes.string, // String
    doNotMixUp: PropTypes.string, // String
    omnidiaSynonym: PropTypes.string, // String
    teraOmnidia: PropTypes.string, // String
    populationAspect: PropTypes.string, // String
    flowering: PropTypes.string, // String
    pictureLegend: PropTypes.string, // String
    macrophyteCode: PropTypes.string, // String
    worms: PropTypes.string, // String
    aspe: PropTypes.string, // String
    spomnidia: PropTypes.string, // String
    calculate: PropTypes.bool, // Boolean
    labelWithCode: PropTypes.string, // String
    link_documents: PropTypes.array, // Array
})